import { render, staticRenderFns } from "./forwardDialog.vue?vue&type=template&id=7e822a29"
import script from "./forwardDialog.vue?vue&type=script&lang=ts"
export * from "./forwardDialog.vue?vue&type=script&lang=ts"
import style0 from "./forwardDialog.vue?vue&type=style&index=0&id=7e822a29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports